import {
    CREATE_USER_HEADER_REQUEST,
    CREATE_USER_HEADER_SUCCESS,
    CREATE_USER_HEADER_FAILURE,
    DELETE_USER_HEADER_REQUEST,
    DELETE_USER_HEADER_SUCCESS,
    DELETE_USER_HEADER_FAILURE,
    FETCH_SINGLE_USER_HEADER_REQUEST,
    FETCH_SINGLE_USER_HEADER_SUCCESS,
    FETCH_SINGLE_USER_HEADER_FAILURE,
    FETCH_USER_HEADER_REQUEST,
    FETCH_USER_HEADER_SUCCESS,
    FETCH_USER_HEADER_FAILURE,
    UPDATE_USER_HEADER_REQUEST,
    UPDATE_USER_HEADER_SUCCESS,
    UPDATE_USER_HEADER_FAILURE,
    RESET_USER_HEADER_INFO,
    CREATE_USER_HEADER_FORM,
    UPDATE_USER_HEADER_FORM,
    FETCH_COMPANY_SUCCESS,
    FETCH_COMPANY_FAILURE,
    NAVIGATE_USER_DETAILS,
    NAVIGATE_USER_HEADER,
    FETCH_PROPERTY_DATAS_FOR_USER_HEADER_SUCCESS,
    SET_SIGNATURE_FILE_NAME_USER_HEADER,
    FETCH_USER_SIGNATURE_IMAGE_REQUEST,
    FETCH_USER_SIGNATURE_IMAGE_SUCCESS,
    FETCH_USER_SIGNATURE_IMAGE_FAILURE,
    RESET_USER_HEADER
} from './userHeader.actionsType';

export const USER_HEADER = 'userHeader';

let initialState = {
    loading: false,
    userHeader: [],
    designation: [],
    category: [],
    department: [],
    employeeType: [],
    companyData: [],
    userHeaderform: {
        signatureFileName: ''
    },
    selectedState: {},
    errorMessage: '',
    userHeaderId: {},
    signatureFileName: '',
    isUserDetails: false
};

export let userHeaderReducer = (state = initialState, action) => {
    let { type, payload, propertyId, updatePayload } = action;
    switch (type) {
        case FETCH_USER_HEADER_REQUEST:
        case FETCH_USER_SIGNATURE_IMAGE_REQUEST:
        case CREATE_USER_HEADER_REQUEST:
        case UPDATE_USER_HEADER_REQUEST:
        case FETCH_SINGLE_USER_HEADER_REQUEST:
        case DELETE_USER_HEADER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeader: updatePayload
            };
        case FETCH_USER_SIGNATURE_IMAGE_SUCCESS:
            var imageId = `data:image/png;base64,${updatePayload}`;
            var arr = imageId.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            // console.log(
            //     updatePayload ? new File([u8arr], `${state?.userHeaderform?.fldSignature}.png`, { type: `image/png` }) : '',
            //     'hhhhhhhhhhhhhhh'
            // );
            return {
                ...state,
                loading: false,
                signatureFileName: `data:image/png;base64,${updatePayload}`,
                userHeaderform: {
                    ...state.userHeaderform,
                    fldSignatureFile: updatePayload
                        ? new File([u8arr], `${state?.userHeaderform?.fldSignature}.png`, { type: `image/png` })
                        : ''
                }
            };
        case FETCH_PROPERTY_DATAS_FOR_USER_HEADER_SUCCESS:
            if (propertyId == 26) {
                return {
                    ...state,
                    loading: false,
                    designation: payload
                };
            } else if (propertyId == 27) {
                return {
                    ...state,
                    loading: false,
                    category: payload
                };
            } else if (propertyId == 28) {
                return {
                    ...state,
                    loading: false,
                    department: payload
                };
            }

            else if (propertyId == 97) {
                return {
                    ...state,
                    loading: false,
                    generalStyles: payload
                };
            }
            else if (propertyId == 30) {
                return {
                    ...state,
                    loading: false,
                    employeeType: payload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case FETCH_COMPANY_SUCCESS:
            return {
                ...state,
                companyData: updatePayload
            };
        case CREATE_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeaderform: {
                    signatureFileName: ''
                }
            };
        case UPDATE_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeaderform: {
                    signatureFileName: ''
                }
            };
        case FETCH_SINGLE_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeaderform: payload
            };
        case RESET_USER_HEADER:
            return {
                ...state,
                loading: false,
                userHeaderform: {}
            }
        case SET_SIGNATURE_FILE_NAME_USER_HEADER:
            return {
                ...state,
                loading: false,
                signatureFileName: payload
            };
        case DELETE_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeaderform: {
                    signatureFileName: ''
                }
            };
        case RESET_USER_HEADER_INFO:
            return {
                ...state,
                userHeaderform: {
                    signatureFileName: ''
                },
                signatureFileName: ''
            };
        case CREATE_USER_HEADER_FORM:
        case UPDATE_USER_HEADER_FORM:
            return {
                ...state,
                loading: false,
                userHeaderform: {
                    ...state.userHeaderform,
                    [payload.key]: payload.value
                }
            };
        case NAVIGATE_USER_DETAILS:
            return {
                ...state,
                isUserDetails: true,
                userHeaderId: updatePayload?.userHeaderId
            };
        case NAVIGATE_USER_HEADER:
            return {
                ...state,
                isUserDetails: false
            };
        case FETCH_USER_HEADER_FAILURE:
        case FETCH_USER_SIGNATURE_IMAGE_FAILURE:
        case FETCH_COMPANY_FAILURE:
        case CREATE_USER_HEADER_FAILURE:
        case UPDATE_USER_HEADER_FAILURE:
        case FETCH_SINGLE_USER_HEADER_FAILURE:
        case DELETE_USER_HEADER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
